<template v-title="'征集赞助商'">
    <div style="background: #fff;">
        <div class="form form-collect" v-if="!successSmt">
            <div class="form-item">
                <span class="label"><i class="required">*</i>您的姓名：</span>
                <div class="input-box">
                    <input type="text" class="input" placeholder="姓名" v-model.trim="form.TrueName">
                </div>
            </div>
            <div class="form-item">
                <span class="label"><i class="required">*</i>您的联系方式：</span>
                <div class="input-box">
                    <input type="text" class="input" placeholder="手机号" v-model.trim="form.HandSet">
                </div>
            </div>
            <div class="form-item">
                <span class="label"><i class="required">*</i>您的职称：</span>
                <div class="input-box">
                    <input type="text" class="input" placeholder="职位名称" v-model.trim="form.Position">
                </div>
            </div>
            <div class="form-item">
                <span class="label"><i class="required">*</i>所在机构：</span>
                <div class="input-box">
                    <input type="text" class="input" placeholder="公司名称" v-model.trim="form.Organization">
                </div>
            </div>
            <div class="btn-primary" @click="submit">确定</div>
        </div>
        <div v-else class="successTips">
            <div>
                <p>您已成功提交</p>
                <p>请耐心等候，速派专员会尽快联系您！</p>
                <div class="btn-primary" @click="$router.push({path: '/live'})">返回</div>
            </div>
        </div>
    </div>
</template>
<script>
import { 
    AddServiceForumCollectInfo,   //提交
} from "@/common/api.js";
import valid from '@/common/validate.js'
export default {
    data(){
        return {
            form:{
                TrueName: '',       //姓名
                HandSet: '',        //手机号
                Position: '',       //职位
                Organization: '',   //机构
                CollectInfoType: 2, //征集信息类型 1大咖2赞助
            },
            smtLoading: false,
            successSmt: false,
        }
    },
    methods: {
        submit(){
            if(this.smtLoading) return
            if(!this.form.TrueName) {
                return this.$toast('请输入您的姓名');
            }
            if(!this.form.HandSet){
                return this.$toast('请输入您的手机号');
            }
            if(!valid.phone(this.form.HandSet) && this.form.HandSet!=''){
                return this.$toast('手机号格式不正确');
            }
            if(!this.form.Position) {
                return this.$toast('请输入您的职位名称');
            }
            if(!this.form.Organization) {
                return this.$toast('请输入您的公司名称');
            }
            let data = {
                ...this.form
            }
            this.smtLoading = true
            AddServiceForumCollectInfo(data).then(res => {
                this.smtLoading = false
                if(res.Result !=1) {
                    return this.$toast(res.Message);
                }
                this.successSmt = true
                this.form = {
                    TrueName: '',       //姓名
                    HandSet: '',        //手机号
                    Position: '',       //职位
                    Organization: '',   //机构
                    CollectInfoType: 0, //征集信息类型 1大咖2赞助
                }
            })

        },
    }
}
</script>
<style lang="scss">
@import '~@/style/_base.scss';
    .form-collect{
        &.form {
            width: px2rem(700px);
            margin: px2rem(20px) auto 0;
            padding-top: px2rem(30px);
            padding-bottom: 0px;
        }
        .form-item {
            position: relative;
            margin-bottom: px2rem(20px);
            overflow: hidden;
        }
        .input-box {
            min-height: px2rem(40px);
            position: relative;
            overflow: hidden;
            width: px2rem(460px);
            float: right;
        }
        .icon-location{
            position: absolute;
            right: px2rem(4px);
            top: px2rem(10px);
            font-size: px2rem(20px);
            color: #f75959;
        }
        .form-item .label {
            font-size: px2rem(28px);
            line-height: px2rem(48px);
            font-weight: bold;
            padding: px2rem(16px) 0;
            color: #333;
            width: px2rem(240px);
            float: left;
            padding-right: px2rem(8px);
            text-align: right;
        }
        .form-item .input {
            width: 100%;
            height: px2rem(80px);
            border: 1px solid #e3e3e3;
            font-size: px2rem(28px);
            color: #333;
            padding: px2rem(8px) px2rem(10px);
            line-height: px2rem(22px);
            &.address-input{
                padding-right: px2rem(30px);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .btn-primary{
        display: block;
        width: px2rem(200px);
        height: px2rem(60px);
        line-height: px2rem(60px);
        font-size: px2rem(28px);
        color: #fff;
        background-color: #f75959;
        border-radius: px2rem(8px);
        text-align: center;
        margin: px2rem(60px) auto 0;
        cursor: pointer;
    }
    .successTips {
        padding: px2rem(30px) 0;
        text-align: center;
        font-size: px2rem(22px);
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        p {
            line-height: px2rem(60px);
        }
    }
</style>